import { Scene, Input } from "phaser";
import FullScreen from "../../phaser/components/fullScreen";


export default class Win extends Scene {

    constructor() {
        super({ key: "Win" });
    }
    init(data) {
        this.level = data.level;
        this.characterSelected = data.characterSelected;
        this.lastCoordenates = data.lastCoordenates;
    }

    preload() {
        let file = 'thick_8x8'; // Nombre base de tu fuente
        this.load.bitmapFont('pixelfont', 'fonts/' + file + '.png', 'fonts/' + file + '.xml');
    
        if (this.sys.game.device.os.desktop) {
            this.isMobile = false;
        }
        else {
            this.isMobile = true;
        }


    }
    create() {
        this.spaceBar = this.input.keyboard.addKey(Input.Keyboard.KeyCodes.SPACE);
        this.buttonFullscreen = new FullScreen(this);
        const screenCenterX = this.cameras.main.worldView.x + this.cameras.main.width / 2;
        const screenCenterY = this.cameras.main.worldView.y + this.cameras.main.height / 2;
        const levelsPass = JSON.parse(localStorage.getItem('noL'));
        // this.text = this.add.text(screenCenterX, screenCenterY, `Congratulations! You've found ${levelsPass.length} lightstick(s)!`.toUpperCase(), { font: "35px CustomFont", fill: "#FFFFFF" }).setOrigin(0.5);

        this.add.bitmapText(screenCenterX, screenCenterY, 
            'pixelfont', `Congratulations!\n You've found ${levelsPass.length} lightstick(s)!`.toUpperCase(), 20, 1).setTint(0xFFFFFF).setDepth(1).setOrigin(0.5); 

        setTimeout(() => {
            this.scene.start(`Hallway`, { characterSelected: this.characterSelected, loadAgain: true, lastCoordenates: this.lastCoordenates });
        }, 3000);

    }

    
    update() {


    }


}